export const getNotes = state => state.notes;

export const getCurrentEditNote = state => state.currentEditNote;

export const getProjectId = state => state.projectId;

export const getTaskId = state => state.taskId;

export const getShowForm = state => state.showForm;
